export const errors = {
  verifyErrors: {
    generic: {
      422: { message: 'Your application is being processed. Please check back in a couple of minutes.', type: 'info' },
      500: { message: 'Something went wrong. Please try again later.', type: 'error' },
      404: { message: "Email address not found, either you haven't registered or you have provided an incorrect email address.", type: 'error' },
      409: { message: 'Your account is already verified. Please check your account details and try logging in again.', type: 'error' },
      401: { message: 'Your verification link seems to have expired. Try to log in with your account to trigger a new email.', type: 'error' }
    }
  },
  authErrors: {
    generic: {
      422: { message: 'Your application is being processed. Please check back in a couple of minutes.', type: 'info' },
      500: { message: 'Something went wrong. Please try again later.', type: 'error' },
      404: { message: 'User not found, please try again in a few minutes.', type: 'error' },
      409: { message: 'A user has already registered using those details.', type: 'error' },
      401: { message: 'Something went wrong. Please try again later.', type: 'error' }
    }
  },
  applicationErrors: {
    generic: {
      422: { message: "We're just getting your application up to date. Please refresh the page in a couple of minutes.", type: 'info' },
      500: { message: 'Something went wrong retrieving your Application. Please try again later.', type: 'error' },
      404: { message: 'Application not found, please try again in a few minutes.', type: 'error' },
      409: { message: 'Application already exists.', type: 'error' }
    },
    put: {
      500: { message: 'Something went wrong updating your Application. Please try again later.', type: 'error' }
    }
  },
  childEntityErrors: {
    generic: {
      422: { message: 'Your items are being synced. Please try again later.', type: 'info' },
      500: { message: 'Something went wrong adding your items. Please try again later.', type: 'error' },
      404: { message: 'No items were found.', type: null }
    },
    get: {
      500: { message: 'Something went wrong retrieving your items. Please try again later.', type: 'error' }
    },
    post: {
      500: { message: 'Something went wrong adding your items. Please try again later.', type: 'error' }
    },
    put: {
      500: { message: 'Something went wrong updating this item. Please try again later.', type: 'error' }
    },
    delete: {
      500: { message: 'Something went wrong deleting this item. Please try again later.', type: 'error' }
    }
  },
  claimErrors: {
    generic: {
      422: { message: "We're just getting your claim up to date. Please refresh the page in a couple of minutes.', type: 'info" },
      500: { message: 'Something went wrong retrieving your claim. Please try again later.', type: 'error' },
      404: { message: 'Claim not found, please try again in a few minutes.', type: 'error' },
      409: { message: 'Claim already exists.', type: 'error' }
    },
    put: {
      500: { message: 'Something went wrong updating your claim. Please try again later.', type: 'error' }
    }
  },
  eoiErrors: {
    generic: {
      422: { message: "We're just getting your expression of interest application up to date. Please refresh the page in a couple of minutes.", type: 'info' },
      500: { message: 'Something went wrong retrieving your Expression of Interest Application. This may be because you are a brand new user, Please try refreshing the page in a couple of minutes.', type: 'error' },
      404: { message: 'Expression of Interest Application not found, please try again in a few minutes.', type: 'error' },
      409: { message: 'Expression of Interest Application already exists.', type: 'error' }
    },
    put: {
      500: { message: 'Something went wrong updating your expression of interest Application. This may be because you are a brand new user, Please try refreshing the page in a couple of minutes.', type: 'error' }
    }
  },
  notesErrors: {
    generic: {
      422: { message: 'It looks like your files are still saving so the below list may not be up to date just yet. Please check back in a couple of minutes.', type: 'info' },
      500: { message: 'Something went wrong retrieving your files. Please try again later.', type: 'error' },
      404: { message: 'No uploaded files were found.', type: null },
      failures: { message: 'The following files have failed to upload. Please check the guidance and try again:.', type: 'error' }
    }
  },
  docManagementStatusErrors: {
    generic: {
      500: { message: 'Something went wrong finding the status of document uploads for this application.', type: 'error' },
      404: { message: 'Unable to find the status of document uploads for this application', type: 'error' },
      401: { message: 'We are unable to authorise your user. Please try logging in again', type: 'error' }
    }
  }
};

export default errors;
